export default {"src":"/_next/static/media/bokchoy.8238374c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};